module.exports = __webpack_public_path__ + "static/media/pdf_512.0709416d.png";